
import Vue from 'vue';

export default Vue.extend({
	name: 'BaseProgress',
	props: {
		height: {
			type: [Number, String],
			default: 15
		},
		value: {
			type: [Number, String],
			required: true,
		},
		max: {
			type: [Number, String],
			default: 100,
		},
	},
	computed: {
		normalizedValue(): number {
			const val = parseFloat(String(this.value));
			const maxVal = parseFloat(String(this.max));

			if (isNaN(val) || isNaN(maxVal) || maxVal <= 0) {
				return 0;
			}

			return (val / maxVal) * 100;
		},
	},
});
